// Bloc du tableau de bord : points de décision et de garantie en attente (aucun classement de candidats).
import { Link } from "react-router";
import { useGet } from "@core/hooks";
import { useOrg } from "@core/org";
import { Card, Stat } from "@core/ui";

type Summary = {
  contestations_ouvertes: number;
  corrections_ouvertes: number;
  confirmations_employeur_en_attente: number;
  visas_a_suivre: number;
  engagements_garants_en_cours: number;
};

export function DecisionDashboard({ orgId }: { orgId: string }) {
  const org = useOrg();
  const q = useGet<Summary>(`/api/v1/orgs/${orgId}/decision-summary`);
  const s = q.data;
  if (!s) return null;
  const total = s.contestations_ouvertes + s.corrections_ouvertes + s.confirmations_employeur_en_attente + s.visas_a_suivre + s.engagements_garants_en_cours;
  if (!total) return null;
  return (
    <Card title="Décisions et garanties à suivre">
      <div className="stats">
        <Stat label="Demandes de candidats à traiter" value={s.contestations_ouvertes} hint={s.contestations_ouvertes ? <Link to={org.to("contestations")}>Répondre</Link> : undefined} />
        <Stat label="Corrections en attente du candidat" value={s.corrections_ouvertes} />
        <Stat label="Confirmations employeur en cours" value={s.confirmations_employeur_en_attente} />
        <Stat label="Visas Visale à suivre" value={s.visas_a_suivre} />
        <Stat label="Engagements de garants en cours" value={s.engagements_garants_en_cours} />
      </div>
    </Card>
  );
}
